var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,15V10c0.5-0.4,1-0.9,1-1.6c0-1-0.9-1.9-1.9-1.9c-0.5,0-0.9,0.1-1.1,0.4l-4.1-2.3c0-0.1,0-0.2,0-0.2 c0-1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.9c0,0.1,0,0.2,0,0.2L6.5,6.9C6.3,6.7,5.8,6.6,5.4,6.6c-1,0-1.9,0.9-1.9,1.9 c0,0.7,0.4,1.2,1,1.6V15c-0.5,0.4-1,0.9-1,1.6c0,1,0.9,1.9,1.9,1.9c0.5,0,0.9-0.1,1.1-0.4l4.1,2.3c0,0.1,0,0.2,0,0.2 c0,1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9c0-0.1,0-0.2,0-0.2l4.1-2.3c0.4,0.2,0.7,0.4,1.1,0.4c1,0,1.9-0.9,1.9-1.9 C21.5,16,21.1,15.3,20.5,15z M6.3,13.5V10C6.8,9.8,7,9.3,7.1,8.8L10,7.2L6.3,13.5z M13.1,18.9c-0.2-0.1-0.4-0.1-0.6-0.1 c-0.2,0-0.4,0-0.6,0.1l-2.7-1.5h6.7L13.1,18.9z M7.3,15.6l5.2-9l5.2,8.9H7.3V15.6z M18.6,13.7l-3.8-6.5l3,1.6 c0.1,0.5,0.5,1,0.9,1.2V13.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/APIIcon.7e81fff80a57f1ac60211d2bf0cef1bf.svg";
export { ForwardRef as ReactComponent };